import { useCallback, useState } from 'react'

// eslint-disable-next-line no-unused-vars
import { IData } from '../interfaces/table'
// eslint-disable-next-line no-unused-vars
import { IOrder } from '../interfaces/order'

export const useOrder = () => {
  const [order, setOrder] = useState<IOrder>(undefined)

  const isOrdering = useCallback(() => {
    return !!order
  }, [order])

  const isSelectedColumn = (data: string) => {
    return data === order?.column
  }

  const handlersOrderToggle = {
    undefined: (column: string) => {
      setOrder({
        column,
        type: 'asc'
      })
    },
    asc: (column: string) => {
      setOrder({
        column,
        type: 'desc'
      })
    },
    desc: (_column: string) => {
      setOrder(undefined)
    }
  }

  const onToggle = (column: string) => {
    if (order?.column !== column) {
      setOrder({
        column,
        type: 'asc'
      })
      return
    }

    handlersOrderToggle[!order ? 'undefined' : order!.type](column)
  }

  const sort = useCallback((data: IData, order: IOrder) => {
    const { column, type } = order!

    const orderedData = data.sort((a, b) => {
      if (type === 'asc') {
        return a[column] > b[column] ? 1 : -1
      }

      return a[column] < b[column] ? 1 : -1
    })

    return orderedData
  }, [])

  return { order, setOrder, isOrdering, isSelectedColumn, onToggle, sort }
}
